<app-page-breadcrumb pageTitle="Chatflows" />

<div class="space-y-6">
  <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
    <div class="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
      <div class="max-w-3xl">
        <h2 class="text-xl font-semibold text-gray-800 dark:text-white">Biblioteca de chatflows</h2>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Administra chatflows de chat en vivo, bot y chatbot con IA. Desde aquí puedes revisar su prioridad,
          validar publicación y entrar al constructor del flujo.
        </p>
      </div>

      <button
        *appHasPermission="'chatflows:create'"
        (click)="nuevoChatflow()"
        class="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600">
        Nuevo chatflow
      </button>
    </div>

    <div class="mt-6 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      <div class="rounded-2xl border border-gray-200 bg-gray-50 p-4 dark:border-gray-800 dark:bg-gray-950/40">
        <div class="text-xs uppercase tracking-wide text-gray-400 dark:text-gray-500">Activos</div>
        <div class="mt-2 text-2xl font-semibold text-gray-800 dark:text-white">{{ totalActive }}</div>
      </div>
      <div class="rounded-2xl border border-gray-200 bg-gray-50 p-4 dark:border-gray-800 dark:bg-gray-950/40">
        <div class="text-xs uppercase tracking-wide text-gray-400 dark:text-gray-500">En borrador</div>
        <div class="mt-2 text-2xl font-semibold text-gray-800 dark:text-white">{{ totalDraft }}</div>
      </div>
      <div class="rounded-2xl border border-gray-200 bg-gray-50 p-4 dark:border-gray-800 dark:bg-gray-950/40">
        <div class="text-xs uppercase tracking-wide text-gray-400 dark:text-gray-500">Listos para publicar</div>
        <div class="mt-2 text-2xl font-semibold text-gray-800 dark:text-white">{{ totalReadyToPublish }}</div>
      </div>
      <div class="rounded-2xl border border-gray-200 bg-gray-50 p-4 dark:border-gray-800 dark:bg-gray-950/40">
        <div class="text-xs uppercase tracking-wide text-gray-400 dark:text-gray-500">Bots y AI</div>
        <div class="mt-2 text-2xl font-semibold text-gray-800 dark:text-white">{{ totalBots }}</div>
      </div>
    </div>

    <div class="mt-6 grid gap-4 md:grid-cols-3 xl:grid-cols-5">
      <div>
        <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">Estado</label>
        <select
          [(ngModel)]="filtroEstado"
          [disabled]="vistaArchivados"
          class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-white">
          <option value="">Todos</option>
          @for (estado of estadosActivos; track estado) {
            <option [value]="estado">{{ getStatusLabel(estado) }}</option>
          }
        </select>
      </div>

      <div>
        <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">Tipo</label>
        <select
          [(ngModel)]="filtroTipo"
          class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white">
          <option value="">Todos</option>
          @for (tipo of tipos; track tipo) {
            <option [value]="tipo">{{ getTypeLabel(tipo) }}</option>
          }
        </select>
      </div>

      <div class="md:col-span-3 xl:col-span-2">
        <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">Buscar</label>
        <div class="relative">
          <span class="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-500">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-4.35-4.35M17 10.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"></path>
            </svg>
          </span>
          <input
            type="text"
            [(ngModel)]="filtroBusqueda"
            (ngModelChange)="onBusquedaChange()"
            placeholder="Buscar por nombre o identificador..."
            class="w-full rounded-lg border border-gray-300 bg-white py-2 pl-9 pr-3 text-sm text-gray-800 placeholder-gray-400 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:placeholder-gray-500" />
        </div>
        <a routerLink="/chatflows/plantillas"
          class="mt-1.5 inline-flex items-center gap-1 text-xs text-brand-500 transition-colors hover:text-brand-600 hover:underline dark:text-brand-400 dark:hover:text-brand-300">
          {{ templates.length }} plantillas activas en la biblioteca
          <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>

      <div class="flex items-end gap-3">
        <button
          (click)="buscar()"
          class="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600">
          Filtrar
        </button>
        <button
          (click)="limpiarFiltros()"
          class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
          Limpiar
        </button>
      </div>
    </div>
  </div>

  @if (templateError) {
    <div class="rounded-xl border border-warning-200 bg-warning-50 p-4 text-sm text-warning-700 dark:border-warning-500/20 dark:bg-warning-500/10 dark:text-warning-400">
      {{ templateError }}
    </div>
  }

  @if (actionMessage) {
    <div class="rounded-xl border border-success-200 bg-success-50 p-4 text-sm text-success-700 dark:border-success-500/20 dark:bg-success-500/10 dark:text-success-400">
      {{ actionMessage }}
    </div>
  }

  @if (actionError) {
    <div class="rounded-xl border border-error-200 bg-error-50 p-4 text-sm text-error-600 dark:border-error-500/20 dark:bg-error-500/10 dark:text-error-400 flex items-start justify-between gap-4">
      <span>{{ actionError }}</span>
      <button (click)="actionError = ''" class="shrink-0 text-lg font-bold leading-none opacity-60 hover:opacity-100">&times;</button>
    </div>
  }

  <div class="rounded-2xl border border-gray-200 bg-white shadow-sm dark:border-gray-800 dark:bg-gray-900">
    @if (loading) {
      <div class="flex items-center justify-center px-6 py-16">
        <div class="h-8 w-8 animate-spin rounded-full border-b-2 border-brand-500"></div>
        <span class="ml-3 text-sm text-gray-500 dark:text-gray-400">Cargando chatflows...</span>
      </div>
    }

    @if (error) {
      <div class="m-6 rounded-xl border border-error-200 bg-error-50 p-4 dark:border-error-500/20 dark:bg-error-500/10">
        <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    }

    @if (!loading && !error) {
      <!-- Secciones: los chatflows archivados viven separados de los que están en uso (INC_CRM_019 #20) -->
      <div class="flex gap-1 border-b border-gray-200 px-4 pt-3 dark:border-gray-800">
        <button type="button" (click)="verArchivados(false)"
          class="rounded-t-lg px-4 py-2.5 text-sm font-medium transition-colors -mb-px border-b-2"
          [ngClass]="!vistaArchivados ? 'border-brand-500 text-brand-600 dark:text-brand-400' : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'">
          Activos
          <span class="ml-1.5 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-600 dark:bg-gray-800 dark:text-gray-300">{{ countActivos }}</span>
        </button>
        <button type="button" (click)="verArchivados(true)"
          class="rounded-t-lg px-4 py-2.5 text-sm font-medium transition-colors -mb-px border-b-2"
          [ngClass]="vistaArchivados ? 'border-brand-500 text-brand-600 dark:text-brand-400' : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'">
          Archivados
          <span class="ml-1.5 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-600 dark:bg-gray-800 dark:text-gray-300">{{ countArchivados }}</span>
        </button>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full min-w-[920px] text-sm">
          <thead>
            <tr class="border-b border-gray-200 text-left text-xs font-medium uppercase tracking-wide text-gray-500 dark:border-gray-800 dark:text-gray-400">
              <th class="px-4 py-3">Chatflow</th>
              <th class="px-4 py-3">Tipo</th>
              <th class="px-4 py-3">Estado</th>
              <th class="px-4 py-3">Validación</th>
              <th class="px-4 py-3">Prioridad</th>
              <th class="px-4 py-3">Plantilla</th>
              <th class="px-4 py-3">Actualizado</th>
              <th class="px-4 py-3 text-center">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (chatflow of chatflowsVisibles; track chatflow.id) {
              <tr class="align-top transition hover:bg-gray-50 dark:hover:bg-gray-800/40">
                <td class="px-4 py-4">
                  <div class="font-medium text-gray-800 dark:text-white">{{ chatflow.name }}</div>
                  <div class="mt-1 text-xs text-gray-400 dark:text-gray-500">
                    <span class="font-mono" [title]="'Identificador técnico interno: ' + chatflow.identifier">Ref: {{ chatflow.identifier }}</span>
                  </div>
                </td>

                <td class="px-4 py-4">
                  <div class="font-medium text-gray-700 dark:text-gray-200">{{ getTypeLabel(chatflow.chatflowType) }}</div>
                  @if (chatflow.chatflowType === 'AI_CHATBOT') {
                    <span class="mt-1.5 inline-flex items-center gap-1 rounded-full bg-purple-50 px-2 py-0.5 text-[10px] font-semibold text-purple-600 ring-1 ring-inset ring-purple-400/30 dark:bg-purple-500/10 dark:text-purple-400">
                      Próximamente
                    </span>
                  }
                </td>

                <td class="px-4 py-4">
                  <app-badge [color]="getStatusColor(chatflow.status)">
                    {{ getStatusLabel(chatflow.status) }}
                  </app-badge>
                </td>

                <td class="px-4 py-4">
                  <app-badge [color]="getValidationColor(chatflow.validationStatus)">
                    {{ getValidationLabel(chatflow.validationStatus) }}
                  </app-badge>
                </td>

                <td class="px-4 py-4">
                  <span
                    class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium {{ getPriorityBadgeClass(chatflow.priority) }}"
                    [title]="'Prioridad ' + chatflow.priority + ' — menor valor = mayor prioridad'">
                    {{ getPriorityLabel(chatflow.priority) }}
                  </span>
                </td>

                <td class="px-4 py-4 text-gray-600 dark:text-gray-300">
                  <div>{{ getTemplateName(chatflow.templateId) }}</div>
                  @if (getTemplateCategory(chatflow.templateId); as categoria) {
                    <div class="mt-1 text-xs text-gray-500 dark:text-gray-400">{{ getCategoryLabel(categoria) }}</div>
                  }
                </td>

                <td class="px-4 py-4 text-gray-500 dark:text-gray-400">
                  <div class="space-y-1 text-xs">
                    <div>Act: {{ chatflow.datetimeUpdated | date:'dd/MM/yyyy HH:mm' }}</div>
                    @if (chatflow.publishedAt) {
                      <div class="text-success-600 dark:text-success-400">Pub: {{ chatflow.publishedAt | date:'dd/MM/yyyy HH:mm' }}</div>
                    }
                    @if (chatflow.archivedAt) {
                      <div class="text-gray-400">Arch: {{ chatflow.archivedAt | date:'dd/MM/yyyy HH:mm' }}</div>
                    }
                    @if (chatflow.lastValidatedAt) {
                      <div class="text-brand-600 dark:text-brand-400">Val: {{ chatflow.lastValidatedAt | date:'dd/MM/yyyy HH:mm' }}</div>
                    }
                  </div>
                </td>

                <td class="px-4 py-4">
                  <div class="flex items-center justify-center gap-1">
                    <!-- Ver detalle -->
                    <button (click)="verDetalle(chatflow)" title="Ver detalle"
                      class="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200">
                      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                      </svg>
                    </button>

                    <!-- Editar: acceso ÚNICO al editor. Antes convivían "Diseñar flujo"
                         (icono), "Reglas del widget" y "Configurar" en el menú, y las cuatro
                         acababan en la misma pantalla (INC_CRM_019 (3) inc19). -->
                    <button (click)="editarChatflow(chatflow)" title="Editar"
                      class="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200">
                      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                      </svg>
                    </button>

                    <!-- Validar publicación -->
                    <button (click)="alternarValidacion(chatflow)" [disabled]="validationLoadingId === chatflow.id"
                      [title]="validationLoadingId === chatflow.id ? 'Validando...' : 'Validar publicación'"
                      class="rounded-lg p-2 text-gray-500 transition-colors hover:bg-brand-50 hover:text-brand-600 disabled:cursor-wait disabled:opacity-60 dark:text-gray-400 dark:hover:bg-brand-500/10 dark:hover:text-brand-400">
                      @if (validationLoadingId === chatflow.id) {
                        <span class="block h-4 w-4 animate-spin rounded-full border-b-2 border-brand-500"></span>
                      } @else {
                        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                        </svg>
                      }
                    </button>

                    <!-- Activar / desactivar -->
                    @if (chatflow.status !== 'ACTIVE') {
                      @if (isActivationBlocked(chatflow)) {
                        <span title="AI Chatbot todavía no está disponible en esta versión."
                          class="cursor-not-allowed rounded-lg p-2 text-purple-300 dark:text-purple-700">
                          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"></path>
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                          </svg>
                        </span>
                      } @else {
                        <button (click)="actualizarEstado(chatflow, 'ACTIVE')" title="Activar"
                          class="rounded-lg p-2 text-success-600 transition-colors hover:bg-success-50 hover:text-success-700 dark:text-success-500 dark:hover:bg-success-500/10 dark:hover:text-success-400">
                          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"></path>
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                          </svg>
                        </button>
                      }
                    } @else {
                      <button (click)="actualizarEstado(chatflow, 'DRAFT')" title="Desactivar (enviar a borrador)"
                        class="rounded-lg p-2 text-warning-600 transition-colors hover:bg-warning-50 hover:text-warning-700 dark:text-warning-500 dark:hover:bg-warning-500/10 dark:hover:text-warning-400">
                        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                      </button>
                    }

                    <!-- Duplicar -->
                    <button (click)="abrirDuplicar(chatflow)" title="Duplicar"
                      class="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200">
                      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
                      </svg>
                    </button>

                    <!-- Archivar -->
                    @if (chatflow.status !== 'ARCHIVED') {
                      <button (click)="actualizarEstado(chatflow, 'ARCHIVED')" title="Archivar"
                        class="rounded-lg p-2 text-gray-500 transition-colors hover:bg-error-50 hover:text-error-600 dark:text-gray-400 dark:hover:bg-error-500/10 dark:hover:text-error-400">
                        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"></path>
                        </svg>
                      </button>
                    }

                    <!-- Ver errores de validación -->
                    @if (chatflow.validationStatus === 'INVALID') {
                      <button (click)="toggleErrores(chatflow)"
                        [title]="expandedErrorId === chatflow.id ? 'Ocultar errores' : 'Ver errores de validación'"
                        class="rounded-lg p-2 text-error-500 transition-colors hover:bg-error-50 hover:text-error-600 dark:text-error-400 dark:hover:bg-error-500/10">
                        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                        </svg>
                      </button>
                    }

                    <!-- Eliminar -->
                    <button (click)="eliminarChatflow(chatflow)" title="Eliminar"
                      class="rounded-lg p-2 text-error-500 transition-colors hover:bg-error-50 hover:text-error-600 dark:text-error-400 dark:hover:bg-error-500/10 dark:hover:text-error-300">
                      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                      </svg>
                    </button>

                    <!-- Más acciones -->
                    <div class="relative">
                      <button (click)="toggleMenu(chatflow, $event)" title="Más acciones"
                        class="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200">
                        <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 8a2 2 0 100-4 2 2 0 000 4zm0 6a2 2 0 100-4 2 2 0 000 4zm0 6a2 2 0 100-4 2 2 0 000 4z"></path>
                        </svg>
                      </button>
                      @if (openMenuId === chatflow.id) {
                        <div class="absolute right-0 mt-1 z-dropdown w-52 rounded-lg border border-gray-200 bg-white py-1 shadow-lg dark:border-gray-700 dark:bg-gray-800">
                          <button (click)="abrirGuardarPlantilla(chatflow)"
                            class="w-full px-3 py-2 text-left text-xs font-medium text-gray-700 transition-colors hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700/50">
                            Guardar como plantilla
                          </button>
                          @if (chatflow.status === 'ARCHIVED') {
                            <button (click)="actualizarEstado(chatflow, 'DRAFT')"
                              class="w-full px-3 py-2 text-left text-xs font-medium text-gray-700 transition-colors hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700/50">
                              Enviar a borrador
                            </button>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </td>
              </tr>

              @if (expandedErrorId === chatflow.id) {
                <tr class="bg-error-50/60 dark:bg-error-900/10">
                  <td colspan="8" class="px-4 pb-5 pt-0">
                    <div class="mx-2 rounded-xl border border-error-200 bg-white p-4 dark:border-error-800 dark:bg-gray-900">
                      <div class="flex flex-wrap items-center gap-3">
                        <app-badge color="error">
                          Pendiente de correcciones
                        </app-badge>
                        <span class="text-xs text-gray-500 dark:text-gray-400">
                          Estos errores fueron identificados por el backend en la validación:
                        </span>
                      </div>

                      @if (chatflow.validationErrors && chatflow.validationErrors.length) {
                        <ul class="mt-3 space-y-1 text-sm text-error-700 dark:text-error-400">
                          @for (issue of chatflow.validationErrors; track $index) {
                            <li>• @if (issue.nodeName || issue.nodeKey) {<span class="font-medium">[{{ issue.nodeName || issue.nodeKey }}]</span> }{{ issue.message }}</li>
                          }
                        </ul>
                      } @else {
                        <p class="mt-3 text-sm text-error-700 dark:text-error-400">
                          Hay observaciones de validación pero no se han detallado.
                        </p>
                      }
                    </div>
                  </td>
                </tr>
              }
            }
            @empty {
              <tr>
                <td colspan="8" class="px-4 py-12 text-center text-sm text-gray-500 dark:text-gray-400">
                  @if (filtroBusqueda) {
                    No hay chatflows que coincidan con la búsqueda.
                  } @else if (vistaArchivados) {
                    No hay chatflows archivados.
                  } @else {
                    No hay chatflows para los filtros seleccionados.
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>

<!-- Modal: Guardar chatflow como plantilla -->
<app-modal [isOpen]="showTemplateModal" (close)="cerrarModalPlantilla()" className="max-w-md mx-4 p-6">
  <h3 class="text-lg font-semibold text-gray-800 dark:text-white">Guardar como plantilla</h3>
  @if (templateTarget) {
    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
      Se creará una plantilla reutilizable a partir del flujo actual de "{{ templateTarget.name }}".
    </p>
  }

  @if (templateModalError) {
    <div class="mt-4 rounded-xl border border-error-200 bg-error-50 p-3 text-sm text-error-600 dark:border-error-500/20 dark:bg-error-500/10 dark:text-error-400">
      {{ templateModalError }}
    </div>
  }

  <div class="mt-5 space-y-4">
    <div>
      <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
        Nombre <span class="text-error-500">*</span>
      </label>
      <input
        type="text"
        [(ngModel)]="tplNombre"
        maxlength="120"
        placeholder="Nombre de la plantilla"
        class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:placeholder-gray-500" />
    </div>

    <div>
      <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">Descripción</label>
      <textarea
        [(ngModel)]="tplDescripcion"
        rows="3"
        placeholder="¿Para qué sirve esta plantilla? (opcional)"
        class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:placeholder-gray-500"></textarea>
    </div>

    <div>
      <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">Categoría</label>
      <select
        [(ngModel)]="tplCategoria"
        class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white">
        <option value="">Sin categoría</option>
        @for (categoria of categoriasPlantilla; track categoria.value) {
          <option [value]="categoria.value">{{ categoria.label }}</option>
        }
      </select>
    </div>
  </div>

  <div class="mt-6 flex justify-end gap-3">
    <button
      (click)="cerrarModalPlantilla()"
      [disabled]="savingTemplate"
      class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 disabled:opacity-60 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
      Cancelar
    </button>
    <button
      (click)="guardarComoPlantilla()"
      [disabled]="savingTemplate || !tplNombre.trim()"
      class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-60">
      @if (savingTemplate) {
        <span class="block h-4 w-4 animate-spin rounded-full border-b-2 border-white"></span>
      }
      Guardar plantilla
    </button>
  </div>
</app-modal>

<!-- Modal: Duplicar chatflow (reemplaza window.prompt — INC_CRM_019 #20) -->
<app-modal [isOpen]="showDuplicateModal" (close)="cerrarModalDuplicar()" className="max-w-md mx-4 p-6">
  <h3 class="text-lg font-semibold text-gray-800 dark:text-white">Duplicar chatflow</h3>
  @if (duplicateTarget) {
    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
      Se creará una copia completa de "{{ duplicateTarget.name }}" (flujo, reglas y configuración) con el nombre que indiques.
    </p>
  }

  @if (duplicateModalError) {
    <div class="mt-4 rounded-xl border border-error-200 bg-error-50 p-3 text-sm text-error-600 dark:border-error-500/20 dark:bg-error-500/10 dark:text-error-400">
      {{ duplicateModalError }}
    </div>
  }

  <div class="mt-5">
    <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
      Nombre de la copia <span class="text-error-500">*</span>
    </label>
    <input
      type="text"
      [(ngModel)]="duplicateNombre"
      maxlength="120"
      placeholder="Nombre de la copia"
      class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:placeholder-gray-500" />
  </div>

  <div class="mt-6 flex justify-end gap-3">
    <button
      (click)="cerrarModalDuplicar()"
      [disabled]="duplicatingChatflow"
      class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 disabled:opacity-60 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
      Cancelar
    </button>
    <button
      (click)="confirmarDuplicar()"
      [disabled]="duplicatingChatflow || !duplicateNombre.trim()"
      class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-60">
      @if (duplicatingChatflow) {
        <span class="block h-4 w-4 animate-spin rounded-full border-b-2 border-white"></span>
      }
      Duplicar
    </button>
  </div>
</app-modal>

<!-- Vista detalle: componente propio con la estructura del mockup y el mismo patrón que
     el resto de detalles del sistema (INC_CRM_019 (3) inc21). -->
<app-chatflow-detail-modal
  [isOpen]="showDetailModal"
  [chatflow]="selectedChatflow"
  [templateName]="getTemplateName(selectedChatflow?.templateId)"
  [ownerName]="detailOwnerName"
  (close)="cerrarDetalle()"
  (openEditor)="abrirEditorDesdeDetalle($event)"
  (restored)="cargarChatflows()" />
